import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { BaseRoutes } from '@nts/std';
import { environment } from 'src/environments/environment';

const title = environment ? environment.appTitle : 'Application Title';
const routes: Routes = [

  // #region rotte con autenticazione
  ...BaseRoutes.getBaseAuthentictedRoutes(
    environment,
    [
      // ...BaseRoutes.getEntityRoutes(
      //     title,
      //     'brand',
      //     () => import('./brand/brand.module').then(m => m.BrandModule)
      // ),
      ...BaseRoutes.getEntityRoutes(
        title,
        'f24movement',
        () => import('./f24-movement/f24-movement.module').then(m => m.F24MovementModule)
      ),
      ...BaseRoutes.getEntityRoutes(
        title,
        'f24tenantconfiguration',
        () => import('./f24-tenant-configuration/f24-tenant-configuration.module').then(m => m.F24TenantConfigurationModule)
      ),
      ...BaseRoutes.getEntityRoutes(
        title,
        'f24modelsettings',
        () => import('./f24-model-settings/f24-model-settings.module').then(m => m.F24ModelSettingsModule)
      ),
      ...BaseRoutes.getEntityRoutes(
        title,
        'f24batch',
        () => import('./f24-batch/f24-batch.module').then(m => m.F24BatchModule)
      ),
      ...BaseRoutes.getEntityRoutes(
        title,
        'f24modellistlongop',
        () => import('./f24-model-list-long-op/f24-model-list-long-op.module').then(m => m.F24ModelListLongOpModule)
      ),
      ...BaseRoutes.getEntityRoutes(
        title,
        'f24modeleditlongop',
        () => import('./f24-model-edit-long-op/f24-model-edit-long-op.module').then(m => m.F24ModelEditLongOpModule)
      ),
      ...BaseRoutes.getEntityRoutes(
        title,
        'treasurysection',
        () => import('./treasury-section/treasury-section.module').then(m => m.TreasurySectionModule)
      ),
      ...BaseRoutes.getEntityRoutes(
        title,
        'regionsection',
        () => import('./region-section/region-section.module').then(m => m.RegionSectionModule)
      ),
      ...BaseRoutes.getEntityRoutes(
        title,
        'othersocialsecuritysection',
        () => import('./other-social-security-section/other-social-security-section.module').then(m => m.OtherSocialSecuritySectionModule)
      ),
      ...BaseRoutes.getEntityRoutes(
        title,
        'localsection',
        () => import('./local-section/local-section.module').then(m => m.LocalSectionModule)
      ),
      ...BaseRoutes.getEntityRoutes(
        title,
        'inpssection',
        () => import('./inps-section/inps-section.module').then(m => m.InpsSectionModule)
      ),
      ...BaseRoutes.getEntityRoutes(
        title,
        'inailsection',
        () => import('./inail-section/inail-section.module').then(m => m.InailSectionModule)
      ),
      ...BaseRoutes.getEntityRoutes(
        title,
        'importvatperiodicsettlementtaxeslongop',
        () => import('./import-vat-periodic-settlement-taxes-long-op/import-vat-periodic-settlement-taxes-long-op.module').then(m => m.ImportVatPeriodicSettlementTaxesLongOpModule)
      ),
      ...BaseRoutes.getEntityRoutes(
        title,
        'importwithholdingtaxeslongop',
        () => import('./import-withholding-taxes-long-op/import-withholding-taxes-long-op.module').then(m => m.ImportWithholdingTaxesLongOpModule)
      ),
      ...BaseRoutes.getEntityRoutes(
        title,
        'showtaxextractiondetailslongop',
        () => import('./show-tax-extraction-details-long-op/show-tax-extraction-details-long-op.module').then(m => m.ShowTaxExtractionDetailsLongOpModule)
      ),
      ...BaseRoutes.getEntityRoutes(
        title,
        'importstampdutytaxeslongop',
        () => import('./import-stamp-duty-taxes-long-op/import-stamp-duty-taxes-long-op.module').then(m => m.ImportStampDutyTaxesLongOpModule)
      ),
      ...BaseRoutes.getEntityRoutes(
        title,
        'importelectronicinvoicestampdutieslongop',
        () => import('./import-electronic-invoice-stamp-duties-long-op/import-electronic-invoice-stamp-duties-long-op.module').then(m => m.ImportElectronicInvoiceStampDutiesLongOpModule)
      ),
      ...BaseRoutes.getEntityRoutes(
        title,
        'f24mandatescreationlongop',
        () => import('./f24-mandates-creation-long-op/f24-mandates-creation-long-op.module').then(m => m.F24MandatesCreationLongOpModule)
      ),
      ...BaseRoutes.getEntityRoutes(
        title,
        'f24mandateslistlongop',
        () => import('./f24-mandates-list-long-op/f24-mandates-list-long-op.module').then(m => m.F24MandatesListLongOpModule)
      ),
      ...BaseRoutes.getEntityRoutes(
        title,
        'f24modelandmandatesremovelongop',
        () => import('./f24-model-and-mandates-remove-long-op/f24-model-and-mandates-remove-long-op.module').then(m => m.F24ModelAndMandatesRemoveLongOpModule)
      ),
      ...BaseRoutes.getEntityRoutes(
        title,
        'f24modelcreatefromprofessionalfeenotesmanagementlongop',
        () => import('./f24-model-create-from-professional-fee-notes-management-long-op/f24-model-create-from-professional-fee-notes-management-long-op.module').then(m => m.F24ModelCreateFromProfessionalFeeNotesManagementLongOpModule)
      ),
      ...BaseRoutes.getDefaultRoutes(
        title,
        environment,
        true
      )
    ]
  ),
  // #endregion rotte con autenticazione

  // rotte base per la gestione degli errori
  ...BaseRoutes.getBaseErrorsRoute()

];

@NgModule({
  imports: [
    RouterModule.forRoot(routes),
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
